if ($('#app-form-radio-ranker-station').length) {
    var form_markets;
    var form_curr_stations;
    var form_curr_market;
    var form_curr_dayparts;
    var form_curr_book_limit;
    var form_curr_books;



    var form_curr_area = $("#form_geography option:selected").val();
    var html_all= ' <option value="251,264,">6-11</option>' +
        '                                                                        <option value="251,1,264,8,">6-17</option>' +
        '                                                                        <option value="251,1,254,255,264,8,267,268,">6-24</option>' +
        '                                                                        <option value="251,1,254,255,3,264,8,267,268,10,">6-34</option>' +
        '                                                                        <option value="251,1,254,255,3,4,264,8,267,268,10,11,">6-44</option>' +
        '                                                                        <option value="251,1,254,255,3,4,5,264,8,267,268,10,11,12,">6-49</option>' +
        '                                                                        <option value="251,1,254,255,3,4,5,6,264,8,267,268,10,11,12,13,">6-54</option>' +
        '                                                                        <option value="251,1,254,255,3,4,5,6,82,264,8,267,268,10,11,12,13,14,">6-64</option>' +
        '                                                                        <option value="251,1,254,255,3,4,5,6,82,7,264,8,267,268,10,11,12,13,14,15,">6+</option>' +
        '                                                                        <option value="1,8,">12-17</option>' +
        '                                                                        <option value="1,254,255,8,267,268,">12-24</option>' +
        '                                                                        <option value="1,254,255,3,8,267,268,10,">12-34</option>' +
        '                                                                        <option value="1,254,255,3,4,8,267,268,10,11,">12-44</option>' +
        '                                                                        <option value="1,254,255,3,4,5,8,267,268,10,11,12,">12-49</option>' +
        '                                                                        <option value="1,254,255,3,4,5,6,8,267,268,10,11,12,13,">12-54</option>' +
        '                                                                        <option value="1,254,255,3,4,5,6,82,8,267,268,10,11,12,13,14,">12-64</option>' +
        '                                                                        <option value="1,254,255,3,4,5,6,82,7,8,267,268,10,11,12,13,14,15,">12+</option>' +
        '                                                                        <option value="254,255,267,268,">18-24</option>' +
        '                                                                        <option value="254,255,3,267,268,10,">18-34</option>' +
        '                                                                        <option value="254,255,3,4,267,268,10,11,">18-44</option>' +
        '                                                                        <option value="254,255,3,4,5,267,268,10,11,12,">18-49</option>' +
        '                                                                        <option value="254,255,3,4,5,6,267,268,10,11,12,13,">18-54</option>' +
        '                                                                        <option value="254,255,3,4,5,6,82,267,268,10,11,12,13,14,">8-64</option>' +
        '                                                                        <option value="254,255,3,4,5,6,82,7,267,268,10,11,12,13,14,15,">18</option>' +
        '                                                                        <option value="3,10,">25-34</option>' +
        '                                                                        <option value="3,4,10,11,">25-44</option>' +
        '                                                                        <option value="3,4,5,10,11,12,">25-49</option>' +
        '                                                                        <option value="3,4,5,6,10,11,12,13," >25-54</option>' +
        '                                                                        <option value="3,4,5,6,82,10,11,12,13,14,">25-64</option>' +
        '                                                                        <option value="3,4,5,6,82,7,10,11,12,13,14,15,">25+<option>' +
        '                                                                        <option value="4,11,">35-44</option>' +
        '                                                                        <option value="4,5,11,12,">35-49</option>' +
        '                                                                        <option value="4,5,6,11,12,13,">35-54</option>' +
        '                                                                        <option value="4,5,6,82,11,12,13,14,">35-64</option>' +
        '                                                                        <option value="4,5,6,82,7,11,12,13,14,15,">35+</option>' +
        '                                                                        <option value="5,12,">45-49</option>' +
        '                                                                        <option value="5,6,12,13,">45-54</option>' +
        '                                                                        <option value="5,6,82,12,13,14,">45-64</option>' +
        '                                                                        <option value="5,6,82,7,12,13,14,15,">45+</option>' +
        '                                                                        <option value="6,13,">50-54</option>' +
        '                                                                        <option value="6,82,13,14,">50-64</option>' +
        '                                                                        <option value="6,82,7,13,14,15,">50+</option>' +
        '                                                                        <option value="82,14,">55-64</option>' +
        '                                                                        <option value="82,7,14,15,">54+</option>' +
        '                                                                        <option value="7,15,">65+</option>';

  var html_x= ' <option value="1,8,">12-17</option>' +
      '                                                                        <option value="1,254,255,8,267,268,">12-24</option>' +
      '                                                                        <option value="1,254,255,3,8,267,268,10,">12-34</option>' +
      '                                                                        <option value="1,254,255,3,4,8,267,268,10,11,">12-44</option>' +
      '                                                                        <option value="1,254,255,3,4,5,8,267,268,10,11,12,">12-49</option>' +
      '                                                                        <option value="1,254,255,3,4,5,6,8,267,268,10,11,12,13,">12-54</option>' +
      '                                                                        <option value="1,254,255,3,4,5,6,82,8,267,268,10,11,12,13,14,">12-64</option>' +
      '                                                                        <option value="1,254,255,3,4,5,6,82,7,8,267,268,10,11,12,13,14,15,">12+</option>' +
      '                                                                        <option value="254,255,267,268,">18-24</option>' +
      '                                                                        <option value="254,255,3,267,268,10,">18-34</option>' +
      '                                                                        <option value="254,255,3,4,267,268,10,11,">18-44</option>' +
      '                                                                        <option value="254,255,3,4,5,267,268,10,11,12,">18-49</option>' +
      '                                                                        <option value="254,255,3,4,5,6,267,268,10,11,12,13,">18-54</option>'+
      '                                                                        <option value="254,255,3,4,5,6,82,267,268,10,11,12,13,14,">18-64</option>'+
      '                                                                        <option value="254,255,3,4,5,6,82,7,267,268,10,11,12,13,14,15,">18</option>' +
      '                                                                        <option value="3,10,">25-34</option>' +
      '                                                                        <option value="3,4,10,11,">25-44</option>' +
      '                                                                        <option value="3,4,5,10,11,12,">25-49</option>' +
      '                                                                        <option value="3,4,5,6,10,11,12,13," >25-54</option>' +
      '                                                                        <option value="3,4,5,6,82,10,11,12,13,14,">25-64</option>' +
      '                                                                        <option value="3,4,5,6,82,7,10,11,12,13,14,15,">25+</option>' +
      '                                                                        <option value="4,11,">35-44</option>' +
      '                                                                        <option value="4,5,11,12,">35-49</option>' +
      '                                                                        <option value="4,5,6,11,12,13,">35-54</option>' +
      '                                                                        <option value="4,5,6,82,11,12,13,14,">35-64</option>' +
      '                                                                        <option value="4,5,6,82,7,11,12,13,14,15,">35+<option>' +
      '                                                                        <option value="5,12,">45-49</option>' +
      '                                                                        <option value="5,6,12,13,">45-54</option>' +
      '                                                                        <option value="5,6,82,12,13,14,">45-64</option>' +
      '                                                                        <option value="5,6,82,7,12,13,14,15,">45+</option>' +
      '                                                                        <option value="6,13,">50-54</option>' +
      '                                                                        <option value="6,82,13,14,">50-64</option>' +
      '                                                                        <option value="6,82,7,13,14,15,">50+</option>' +
      '                                                                        <option value="82,14,">55-64</option>' +
      '                                                                        <option value="82,7,14,15,">54+</option>' +
      '                                                                        <option value="7,15,">65+</option>';


    $(document).ready(function(){

        $('#form_geography').on('change',  function () {

            $("#esta").val( $("#form_geography option:selected").val());

                radioRankerOnBooksChange(false, 0);
        });

        show_loader();
        $.ajax({
            type: "GET",
            url: (location.href.indexOf('ratings/eastlan-radio/ranker/station') >= 0 || (typeof edit_market !== 'undefined' && edit_market !== null && edit_market['name'].indexOf('Eastlan') >= 0)) ? '/ratings/eastlan-radio/markets' : '/ratings/radio/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                markets = collect(data).sortBy('name')/*.keyBy('code')*/.all();
                console.log('markets >>>>', markets);

                input.append('<option value=""></option>');
                var se='';
                $.each(markets, function (index, value) {
                    if(editing == true)
                    {
                        if(edit_market !== null && edit_market['code'] === value['code'])
                            se= 'selected';
                        var aux = se !== '' ? 'selected' : '';
                        input.append('<option '+ aux +' value="' + value['code'] + '" data-type="'+ value['type'] +'" >' + value['name'] + '</option>');
                        se='';
                    }
                    else
                    input.append('<option data-type="'+ value['type'] +'" value="' + value['code'] + '">' + value['name'] + '</option>');
                });



                form_markets = data;

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    radioRankerOnMarketChange($(this).val());
                    radioRankerFormReset(1);
                });




                   // $("input:radio[name=rep_cam_exi]").checked= false;

                    radioRankerOnMarketChange($('#form_market').val());
                    radioRankerFormReset(1);

                if(editing == true && pepe=== true){


                    if(edit['primary_demo_type']=='m') {
                        $('#primary_demo_type_m').prop('checked', true);
                        $('.demo_name_primary').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_m').trigger("change");

                    }
                    if(edit['primary_demo_type']=='f'){
                        $('#primary_demo_type_f').prop('checked', true);
                        $('.demo_name_primary').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_f').trigger("change");

                    }
                    if(edit['primary_demo_type']=='p') {
                        $('#primary_demo_type_p').prop('checked', true);
                        $('.demo_name_primary').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_p').trigger("change");

                    }

                    if(edit['secondary_demo_type']=='m') {
                        $('#secondary_demo_type_m').prop('checked', true);
                        $('.demo_name_secondary').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_m').trigger("change");

                    }
                    if(edit['secondary_demo_type']=='f'){
                        $('#secondary_demo_type_f').prop('checked', true);
                        $('.demo_name_secondary').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_f').trigger("change");

                    }
                    if(edit['secondary_demo_type']=='p') {
                        $('#secondary_demo_type_p').prop('checked', true);
                        $('.demo_name_secondary').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_p').trigger("change");


                    }

                }
                $('#primary_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    $(this).closest('.radio-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                  //  $('.demo_name_primary').val($(this).val());
                });

                $('#secondary_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    $(this).closest('.radio-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                   // $('.demo_name_secondary').val($(this).val());
                });




                $('#form_geography').select2({
                    placeholder: "Choose a Market..",
                    minimumResultsForSearch: 10
                }).bind('select2_select', function(){

                   $('input[name="area"]').val( $("#form_geography option:selected").val());

                });

                $('#listening_location').select2()


                $('#form_dayparts').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        if(this.$element.val().length <= 15){
                            radioRankerValidate();
                        }else{
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 15 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_dayparts.length < 15){
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        radioRankerValidate();

                        this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                $('#form_stations').multiSelect(searchableMultiSelectDef);

                $('#form_books').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    radioRankerFormReset();
                });


                hide_loader();
            }
        });
    });




    var radioRankerOnMarketChange = function(val){
        radioRankerFormReset(2);

        show_loader();
        form_curr_market = collect(form_markets).where('code', parseInt(val)).first();
        $('#form_stations').html('');
        var p= $('#form_books');

            $('#primary_demo_type_p').trigger("change");
          //  $('#secondary_demo_type_p').trigger("change");


           /* if(edit['secondary_demo_type']!==null && edit['secondary_demo_type']!=='')
                $('#secondary_demo_type_p').trigger("change");*/



       /* if( typeof form_curr_market !== 'undefined' && form_curr_market['type'] !== 'PPM' && editing===false){
            $('#primary_demo_ids').html("");
            $('#primary_demo_ids').html(html_x);

            }*/




        var input = $('#form_geography');

        if(!editing)
            input.val('Metro').trigger("change");
        else
            input.val(edit.area).trigger("change");
        if( typeof form_curr_market !== 'undefined' && form_curr_market['type'] === 'PPM'){

            input.attr('disabled', 'disabled');
            input.closest('.form-group').find('.help-text').removeClass('hidden');
        }else{
            input.attr('disabled', null);
            input.closest('.form-group').find('.help-text').addClass('hidden');
        }
        if(val !== "" && typeof val !== 'undefined') {
            $.ajax({
                type: "GET",
                url: '/ratings/radio/books/?code=' + val,
                dataType: 'json',
                success: function (data) {
                    var input = $('#form_books');

                    var html = '';
                    if (form_curr_market['frequency'] === 13) {
                        form_curr_book_limit = 13;
                        html = 'Books will be averaged. Maximum of Thirteen.<span class="pull-right"><small><span class="select-count text-muted">(0 / 13)</span></small></span>';
                    } else if (form_curr_market['frequency'] === 4) {
                        form_curr_book_limit = 4;
                        html = 'Books will be averaged. Maximum of Four.<span class="pull-right"><small><span class="select-count text-muted">(0 / 4)</span></small></span>';
                    } else if (form_curr_market['frequency'] === 2) {
                        form_curr_book_limit = 2;
                        html = 'Books will be averaged. Maximum of Two.<span class="pull-right"><small><span class="select-count text-muted">(0 / 2)</span></small></span>';
                    } else {
                        form_curr_book_limit = 1;
                        html = 'Maximum of One.<span class="pull-right"><small><span class="select-count text-muted">(0 / 1)</span></small></span>';
                    }

                    $('.form-books-container').find('.text-default').html(html);

                    input.attr('disabled', null);
                    input.multiSelect('destroy');

                    input.html('');

                    var dates_ordered= data
                    var OrdDates= Object.entries(dates_ordered).sort((a,b) => (a[1].end > b[1].end) ? 1 : ((b[1].end > a[1].end) ? -1 : 0));
                    console.log('OrdDates: ', OrdDates);
                    var cont = OrdDates.length - 1;
                    while(cont >= 0){
                        var value= OrdDates[cont][1];
                        if (editing == true && pepe === true) {
                            var se = 'ex';
                            for (var i in selected_books) {
                                if (value['id'] == selected_books[i])
                                    se = 'selected';
                            }
                            var aux = se !== 'ex' ? 'selected' : '';

                            input.append('<option ' + aux + ' value="' + value['id'] + '">' + value['name'] + '</option>')

                        } else
                            input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                        cont--;
                    }

                    // $.each(data, function (index, value) {
                    //     if (editing == true && pepe === true) {
                    //         var se = 'ex';
                    //         for (var i in selected_books) {
                    //             if (value['id'] == selected_books[i])
                    //                 se = 'selected';
                    //         }
                    //         var aux = se !== 'ex' ? 'selected' : '';
                    //
                    //         input.append('<option ' + aux + ' value="' + value['id'] + '">' + value['name'] + '</option>')
                    //
                    //     } else
                    //         input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                    // });


                    input.multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                        afterInit: function (ms) {
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function (e) {
                                    if (e.which === 40) {
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                            if (editing == true && pepe === true) {
                                form_curr_books = this.$element.val();
                                radioRankerOnBooksChange(false, 2);
                            }
                        },
                        afterSelect: function (values) {
                            this.qs1.cache();
                            form_curr_books = this.$element.val();
                            console.log('values: ', values);
                            var selected = [];
                            var selected_name = [];
                            $('#form_books option').each(function(){
                                if(form_curr_books.indexOf($(this).val()) !== -1){
                                    selected.push($(this).text());
                                    selected_name[$(this).text()] = $(this).val();
                                }
                            });
                            if(selected.indexOf("MARCH 2020") !== -1 && selected_name["MARCH 2020"] == values[0]){
                                var tt = $('#form_market option:selected').attr('data-type');
                                if(tt === 'PPM'){
                                    swal({
                                            title: "Notification",
                                            text: "Given the anomalous nature of audience behavior during the COVID-19 Public Health Emergency, it is Nielsen's position that future buying and planning decisions for periods that fall outside the COVID-19 crisis should not be made using COVID-19 impacted audience estimates.",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonClass: "btn-danger",
                                            confirmButtonText: "OK",
                                            //cancelButtonText: "",
                                            closeOnConfirm: true,
                                            closeOnCancel: true
                                        },
                                        function (isConfirm) {
                                            if(isConfirm){

                                            }
                                        });
                                }
                            }
                            console.log('selected texts: ', selected);
                            if (this.$element.val().length <= form_curr_book_limit) {
                                var const_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
                                var aux = [];
                                for(var ind in selected)
                                    if(selected[ind].indexOf('(') !== -1 && selected[ind].indexOf('Spring') === -1 && selected[ind].indexOf('Summer') === -1 && selected[ind].indexOf('Fall') === -1 && selected[ind].indexOf('Winter') === -1)
                                        aux.push(selected[ind]);
                                var found = false; var results = []; var results2 = [];
                                if(aux.length > 1){
                                    go_out:
                                    for(var ind in aux){
                                        var months = aux[ind].split('(')[1];
                                        var month = aux[ind].split('(')[0];

                                        /**
                                         * NEW CODE
                                         */
                                        var nameMonth = aux[ind].split(' ')[0].trim().toLowerCase();
                                        var yearName = aux[ind].split(' ')[1].trim();
                                        var rangeMonths = aux[ind].split(' ')[2].replace('(','').replace(')','').split('-');
                                        var endDate = Math.round(new Date((yearName) + '-' + (const_months.indexOf(rangeMonths[1].trim().toLowerCase()) + 1)).getTime()/1000);
                                        var initDate = 0;
                                        if(const_months.indexOf(rangeMonths[0].trim().toLowerCase()) > const_months.indexOf(rangeMonths[1].trim().toLowerCase())){
                                            initDate = Math.round(new Date((parseInt(yearName) - 1) + '-' + (const_months.indexOf(rangeMonths[0].trim().toLowerCase()) + 1)).getTime()/1000);
                                            results2[ind] = [
                                                initDate,
                                                endDate
                                            ];

                                        } else {
                                            initDate = Math.round(new Date((yearName) + '-' + (const_months.indexOf(rangeMonths[0].trim().toLowerCase()) + 1)).getTime()/1000);
                                            results2[ind] = [
                                                initDate,
                                                endDate
                                            ];
                                        }
                                        if(results2.length > 1)
                                            for(let pos = results2.length - 2; pos >= 0; pos--){
                                                if(
                                                    (initDate >= results2[pos][0] && initDate <= results2[pos][1]) ||
                                                    (endDate >= results2[pos][0] && endDate <= results2[pos][1])
                                                ){
                                                    found = true;
                                                    break go_out;
                                                }
                                            }
                                        console.log("RESULTS 2: ", results2);

                                        /**
                                         * END NEW CODE
                                         */


                                        if(typeof results[month.split(' ')[1].trim()] === 'undefined')
                                            results[month.split(' ')[1].trim()] = [];
                                        if(months.indexOf(')') !== -1){
                                            months = months.split(')')[0];
                                            months = months.split('-');
                                            if(months.length === 2){
                                                if(months[0].trim() !== '' && months[1].trim() !== ''){
                                                    results[month.split(' ')[1].trim()].push([const_months.indexOf(months[0].trim().toLowerCase()), const_months.indexOf(months[1].trim().toLowerCase())]);
                                                }
                                            }
                                        }
                                    }
                                }
                                console.log('aux: ', aux);
                                console.log('results: ', results);
                                // for(var year in results){
                                //     var books = results[year];
                                //     if(!found)
                                //         for(var i=0;i<books.length-1;i++){
                                //             if(!found)
                                //                 for(var j=i+1;j<books.length;j++){
                                //                     if((books[i][0] >= books[j][0] && books[i][0] <= books[j][1]) || (books[i][1] >= books[j][0] && books[i][1] <= books[j][1])){
                                //                         found = true;
                                //                     }else if((books[j][0] >= books[i][0] && books[j][0] <= books[i][1]) || (books[j][1] >= books[i][0] && books[j][1] <= books[i][1])){
                                //                         found = true;
                                //                     }else if((books[i][0] <= books[j][0] && books[i][1] >= books[j][1]) || (books[j][0] <= books[i][0] && books[j][1] >= books[i][1])){
                                //                         found = true;
                                //                     }
                                //                 }
                                //         }
                                // }
                                var obj_reference = this.$element;
                                if(found){
                                    swal({
                                            title: "Warning",
                                            text: "Nielsen recommends against averaging releases with overlapping surveys.",
                                            type: "warning",
                                            showCancelButton: true,
                                            confirmButtonClass: "btn-danger",
                                            confirmButtonText: "Continue",
                                            cancelButtonText: "Cancel",
                                            closeOnConfirm: true,
                                            closeOnCancel: true
                                        },
                                        function (isConfirm) {
                                            if(isConfirm){
                                                radioRankerOnBooksChange(false, 0);
                                                radioRankerValidate();
                                            }else{
                                                form_curr_books = obj_reference.val();
                                                obj_reference.multiSelect('deselect', values);
                                            }
                                        });
                                }else {
                                    radioRankerOnBooksChange(false, 0);
                                    radioRankerValidate();
                                }
                            } else {
                                form_curr_books = this.$element.val();
                                this.$element.multiSelect('deselect', values);

                                swal({
                                        title: "Warning",
                                        text: (form_curr_book_limit > 1) ? "The max number is " + form_curr_book_limit + "..." : "You can only select one condensed market two-book average survey alone since these surveys already include an average of two consecutive surveys.",
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        cancelButtonText: "Close",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            }

                            if (form_curr_books.length < form_curr_book_limit) {
                                this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / ' + form_curr_book_limit + ')').removeClass('text-warning').addClass('text-muted');
                            } else {
                                this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / ' + form_curr_book_limit + ')').removeClass('text-muted').addClass('text-warning');
                            }
                        },
                        afterDeselect: function (values) {
                            this.qs1.cache();

                            form_curr_books = this.$element.val();
                            if (form_curr_books.length > 0) {
                                radioRankerOnBooksChange(false, 0);
                                radioRankerValidate();


                            } else {
                                radioRankerFormReset(1);
                                radioRankerOnBooksChange(false, 0);

                            }

                            this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / 4)').removeClass('text-warning').addClass('text-muted');

                        }
                    });

                    input.closest('.form-books-container').removeClass('hidden');
                    input.closest('.form-books-container').parent().find('.help-text').addClass('hidden');

                    radioRankerFormReset(2);

                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        }
    };


    var radioRankerOnBooksChange = function(esta, top) {

        var prob = $('#form_books');
        var tt = $(prob).val();
        var si = true;
        if (editing == true) {
            for (var i in  tt) {
                var found = false;
                for (var j in selected_books) {
                    if (tt[i] == selected_books[j])
                        found = true;
                }
                if (found == false) {
                    si = false;
                    break;
                }
            }
        }

        if ($(prob).val() !== null && $(prob).val().length > 0) {
            var parameters = '?';
            $.each(form_curr_books, function (index, value) {
                parameters += 'books[]=' + value + '&';
            });
            console.log("++++++++++++++++");
            console.log($("#form_geography option:selected").val());
            var url = '/ratings/radio/books/stations/' + parameters + '&area=' + $("#form_geography option:selected").val();

            show_loader();
            $.ajax({
                type: "GET",
                url: url,
                dataType: 'json',
                success: function (data) {
                    console.log('stations', data);
                    var input = $('#form_stations');

                    input.attr('disabled', null);
                    input.multiSelect('destroy');

                    input.html('');
                    $.each(data, function (index, value) {
                        if (esta == true) {
                            var aux = 'selected';
                            if (value['id'].indexOf('999999') !== 0)
                                input.append('<option ' + aux + ' value="' + value['id'] + '">' + value['name'] + '</option>')
                        } else if (esta == 'borrar') {
                            if (value['id'].indexOf('999999') !== 0)
                                input.append('<option  value="' + value['id'] + '">' + value['name'] + '</option>')
                        } else if ((editing == true && pepe == true) || (editing == true && si == true)) {

                            var se = 'ex';
                            for (var i in selected_stations) {
                                if (value['id'] == selected_stations[i])
                                    se = 'selected';
                            }
                            var aux = se !== 'ex' ? 'selected' : '';

                            if (value['id'].indexOf('999999') !== 0)
                                input.append('<option ' + aux + ' value="' + value['id'] + '">' + value['name'] + '</option>')

                        } else {

                            if (value['id'].indexOf('999999') !== 0)
                                input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                        }


                    });
                    if (top === 1)
                        var xxx = 'checked';
                    else
                        var xxx = '';

                    if (editing === true) {
                        if (general['top'] == 1 && esta !== 'borrar' && top === 2)
                            var xxx = 'checked';
                    }


                    input.multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;'><input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select All' id='select_all_sta' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect All' id='deselect_all'>" +
                            " <input  id='top_x'  name='top_x'  type='checkbox'  " + xxx + " > Top" +
                            " <input type='number' max='0' disabled min='1' id='stations_number' name='stations_number' style='width: 15%' value='1'> " +
                            "</div>",
                        selectAllText: 'Select All',
                        deselectAllText: 'Deselect All',
                        afterInit: function (ms) {
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function (e) {
                                    if (e.which === 40) {
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        /*afterSelect: function(values){
                            this.qs1.cache();

                            form_curr_stations = this.$element.val();
                            $('#form_submit').attr('disabled', null);
                            if(this.$element.val().length > 20){
                                this.$element.multiSelect('deselect', values);
                                form_curr_stations = this.$element.val();
                                radioRankerValidate();

                                swal({
                                        title: "The limit of Stations is 20...",
                                        text: "",
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        cancelButtonText: "Close",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            }

                            if(form_curr_stations.length < 20){
                                this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                            }else{
                                this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-muted').addClass('text-warning');
                            }
                        },*/
                        /*afterDeselect: function(values){
                            this.qs1.cache();

                            form_curr_stations = this.$element.val();
                            if(form_curr_stations.length === 0){
                                radioRankerValidate();
                            }
                            this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                        }*/
                    });
                    $('#select_all_sta').on('click', function (e) {
                        radioRankerOnBooksChange(true, 0);
                    });

                    $('#deselect_all').on('click', function (e) {
                        radioRankerOnBooksChange('borrar', 0);
                    });


                    if (esta === true && (top === 1 || top === 2) || $("#top_x").is(':checked')) {
                        var max = $('#form_stations');
                        max = $(max).val().length;
                        if (max > 0)
                            $('#stations_number').attr("max", max);
                        else {
                            $('#stations_number').attr("min", 0);
                            $('#stations_number').val(0);
                        }


                        $('#top_x').attr('disabled', false);

                        if (editing === true && top === 2)
                            $('#stations_number').val(general['stations_number']);

                        $('#stations_number').attr("disabled", false);
                    }

                    $('#top_x').on('change', function () {

                        if ($("#top_x").is(':checked')) {
                            radioRankerOnBooksChange(true, 1);

                        } else {
                            radioRankerOnBooksChange('borrar', 0);
                            $('#stations_number').attr("disabled", true);

                        }

                    });
                    $('#form_stations').on('change', function () {
                        var max = $('#form_stations');
                        max = $(max).val().length;


                        if (max > 0)
                            $('#stations_number').attr("max", max);
                        else {
                            $('#stations_number').attr("min", 0);
                            $('#stations_number').val(0);
                        }

                        if ($("#top_x").is(':checked')) {
                            if ($('#stations_number').val() > max)
                                $('#stations_number').val(max);

                        }

                    });


                    if (typeof form_curr_stations !== 'undefined') {
                        if (form_curr_stations.length > 0) {
                            input.multiSelect('select', form_curr_stations);
                            input.multiSelect('refresh');
                            form_curr_stations = input.val();
                        }
                    }


                    input.closest('.form-stations-container').removeClass('hidden');
                    input.closest('.form-stations-container').parent().find('.help-text').addClass('hidden');

                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        } else {
            radioRankerFormReset(2);
        }


    };

    var radioRankerFormReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.data('select2').destroy();
            input.unbind('select2:select');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('select2:select', function (evt) {
                radioRankerOnMarketChange($(this).val());
                radioRankerFormReset(1);
            });

            input = $('#form_geography');

            input.attr('disabled', 'disabled');
            input.find('option[value="MSA"]').select();

            input = $('#form_dayparts');
            input.multiSelect('deselect_all');
            input.closest('.form_dayparts_container').find('.text-default').html('Maximum of Fifteen.<span class="pull-right"><small><span class="select-count text-muted">(0 / 15)</span></small></span>');

            input = $('#form_name').val('');
        }

        if((step < 2) || (step === 'all')) {
            input = $('#form_books');
           // input.multiSelect('destroy');
            //input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_references_container').addClass('hidden');
            input.closest('.form_references_container').parent().find('.help-text').removeClass('hidden');


        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_stations');
            input.multiSelect('destroy');
               input.html('');
           input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_dists_container').addClass('hidden');
            input.closest('.form_dists_container').parent().find('.help-text').removeClass('hidden');

        }

        radioRankerValidate();
    };
    $('#form_submit').on('click', function (e) {

        var market= $("#form_market option:selected").val();
        var stations= $('#form_stations');

        var daypart= $('#form_dayparts');
        var book= $('#form_books');


        var p=false;
        var pp= false;
        if(market !== "")
        {
            if($(book).val().length != 0)
            {
                if( $(stations).val().length != 0 ) {
                    p = true;
                    pp= true;
                }
                else
                    global_notification('warning','Please select at least one Station');
            }
            else
                global_notification('warning','Please select at least one Book');
        }
        else
            global_notification('warning','Please select a Market');



        if($(daypart).val().length == 0 && p== true)
        {
            pp= false;
            global_notification('warning','Please select at least one Daypart');
        }
        if(pp == true) {
            if(editing==true) {
                $('#saved_report_id').val(general['id']);
                $('#reportable_id').val(edit['id']);
                $('#app-form-radio-ranker-station').attr('action', '/ratings/radio/ranker/station/editar');
                $('#app-form-radio-ranker-station').submit();
            }

            else
            $('#app-form-radio-ranker-station').submit();
        }

    });

    var radioRankerValidate = function(){
       /* var inputs = {
            'books': $('#form_books'),
            'dayparts': $('#form_dayparts'),
            'stations': $('#form_stations')
        };

        var pass = false;

        if((inputs['dayparts'].val().length !== 0) && (inputs['stations'].val().length !== 0)  && (inputs['books'].val().length !== 0)){
            pass = true;
        }

        var input_submut = $('#form_submit');

        if(pass){
            input_submut.attr('disabled', null);
        }else{
            input_submut.attr('disabled', 'disabled');
        }*/
    };
    console.log("demos");
    console.log(demos);
    var demos = collect(demos);

  /* $('#secondary_demo_ids').on('change', function () {

   }*/

    $('.radio-select-demo-container input[type="radio"]').on('change', function () {



        var demo_type = $(this).val();
        var select = $($(this).closest('.radio-select-demo-container').find('select')[0]);
        select.html('');
        select.attr('disabled', null);

        if (demo_type === '') {
            select.append('<option value="" selected>-</option>');
            select.attr('disabled', 'disabled');
        } else if (demo_type === 'p') {
            demos.each(function (item) {
                var ids = "";
                var string = "";
                $.each(item['blocks']['p'], function (index, value) {
                            ids += value.toString() + ',';
                });
                var aux='';
                var se='';



                if (item['end'] === null) {
                    string = item['start'] + "+";
                } else {
                    string = item['start'] + "-" + item['end'];
                }
            if($('#form_market :selected').val() !== "") {

                if (form_curr_market['type'] !== 'PPM') {

                    if (string.indexOf('6+') === -1 && string.indexOf('6-') === -1)
                        select.append('<option  value="' + ids + '">' + string + '</option>');
                }
                else
                    select.append('<option   value="' + ids + '">' + string + '</option>');
            }
            else
                select.append('<option  value="' + ids + '">' + string + '</option>');
            });
            if(editing==true )
            {
                if(r===1)
                    var dn = edit['primary_demo_name'];

                if(r===2)
                    var dn= edit['secondary_demo_name'];


               select.find('option').prop('selected', null);
                select.find('option:contains('+ dn +')').prop('selected', 'selected');
            }

        } else {
            demos.each(function (item) {
                var ids = "";
                var string = "";
                $.each(item['blocks'][demo_type], function (index, value) {
                    ids += value.toString() + ',';
                });

                var aux='';
                var se='';


                if (item['end'] === null) {
                    string = item['start'] + "+";
                } else {
                    string = item['start'] + "-" + item['end'];
                }
                if($('#form_market :selected').val() !== "") {

                    if (form_curr_market['type'] !== 'PPM') {

                        if (string.indexOf('6+') === -1 && string.indexOf('6-') === -1)
                            select.append('<option  value="' + ids + '">' + string + '</option>');
                    }
                    else
                        select.append('<option   value="' + ids + '">' + string + '</option>');
                }
                else
                    select.append('<option  value="' + ids + '">' + string + '</option>');
            });

            if(editing==true )
            {
                if(r==1)
                    var dn = edit['primary_demo_name'];

                if(r===2)
                    var dn= edit['secondary_demo_name'];


                select.find('option').prop('selected', null);
                select.find('option:contains('+ dn +')').prop('selected', 'selected');


            }
        }
if(editing===false ) {
    select.find('option').prop('selected', null);
    select.find('option:contains("25-54")').prop('selected', 'selected');
}
        if($(this).attr('to_edit')==='primary')
            $('.demo_name_primary').val($('#primary_demo_ids option:selected').html());
        if($(this).attr('to_edit')==='secondary')
            $('.demo_name_secondary').val($('#secondary_demo_ids option:selected').html());



    });


};
